// extracted by mini-css-extract-plugin
export default {"menu-color":"#222222","menu-color-active":"#e62129","menu-background":"#1890ff","column-second-menu-background":"#fff","menu-main-color-active":"#1890ff"};